/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `photo` - Photo
 * * `press_photo` - Press Photo
 * * `audio` - Audio Sample
 * * `video` - Video
 * * `stage_plot` - Stage Plot
 * * `other` - Other
 * @export
 */
export const MediaTypeEnum = {
    Photo: 'photo',
    PressPhoto: 'press_photo',
    Audio: 'audio',
    Video: 'video',
    StagePlot: 'stage_plot',
    Other: 'other'
} as const;
export type MediaTypeEnum = typeof MediaTypeEnum[keyof typeof MediaTypeEnum];


export function instanceOfMediaTypeEnum(value: any): boolean {
    for (const key in MediaTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(MediaTypeEnum, key)) {
            if (MediaTypeEnum[key as keyof typeof MediaTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MediaTypeEnumFromJSON(json: any): MediaTypeEnum {
    return MediaTypeEnumFromJSONTyped(json, false);
}

export function MediaTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaTypeEnum {
    return json as MediaTypeEnum;
}

export function MediaTypeEnumToJSON(value?: MediaTypeEnum | null): any {
    return value as any;
}

export function MediaTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): MediaTypeEnum {
    return value as MediaTypeEnum;
}

